var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"second_box"},_vm._l((_vm.yp_tabbar),function(item,index){return _c('a',{class:_vm.tabArrindex == index ? 'active' : '',attrs:{"href":"#"},on:{"click":function($event){return _vm.yq_tabbarFn(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }